import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/jobs'
import * as api from '../api/job/jobs'

function* fetchJobs(action) {
  try {
    const payload = yield call(api.getJobList, action)
    yield put({ type: constants.JOBS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOBS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* jobsRefresh() {
  yield takeLatest(constants.JOBS_REFRESH.ACTION, fetchJobs)
}

function* createJob(action) {
  try {
    const payload = {
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createJob, payload)
    yield put({ type: constants.CREATE_JOB.SUCCESS, payload })
    yield call(fetchJobs)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_JOB.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJob() {
  yield takeLatest(constants.CREATE_JOB.ACTION, createJob)
}

export function* rootSaga() {
  yield all([fork(jobsRefresh), fork(watchCreateJob)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobs.js